"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttachmentUploadPurposesEnum = exports.AcceptTCAcceptanceEnum = exports.EnrollmentStepsApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class EnrollmentStepsApi extends runtime.BaseAPI {
    /**
     * Accept or reject platform terms
     */
    async acceptAgreementRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling acceptAgreement.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling acceptAgreement.');
        }
        if (requestParameters.agreement === null || requestParameters.agreement === undefined) {
            throw new runtime.RequiredError('agreement', 'Required parameter requestParameters.agreement was null or undefined when calling acceptAgreement.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/agreements`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.AgreementToJSON(requestParameters.agreement),
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Accept or reject platform terms
     */
    async acceptAgreement(requestParameters) {
        await this.acceptAgreementRaw(requestParameters);
    }
    /**
     * Accept or reject terms & conditions
     */
    async acceptTCRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling acceptTC.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling acceptTC.');
        }
        if (requestParameters.acceptance === null || requestParameters.acceptance === undefined) {
            throw new runtime.RequiredError('acceptance', 'Required parameter requestParameters.acceptance was null or undefined when calling acceptTC.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/tc/{acceptance}`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))).replace(`{${"acceptance"}}`, encodeURIComponent(String(requestParameters.acceptance))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Accept or reject terms & conditions
     */
    async acceptTC(requestParameters) {
        await this.acceptTCRaw(requestParameters);
    }
    /**
     * History -- legal
     */
    async answerLegalQuestionnaireRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling answerLegalQuestionnaire.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling answerLegalQuestionnaire.');
        }
        if (requestParameters.preLegalQuestionnaireStep === null || requestParameters.preLegalQuestionnaireStep === undefined) {
            throw new runtime.RequiredError('preLegalQuestionnaireStep', 'Required parameter requestParameters.preLegalQuestionnaireStep was null or undefined when calling answerLegalQuestionnaire.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/legal-questionnaire`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreLegalQuestionnaireStepToJSON(requestParameters.preLegalQuestionnaireStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * History -- legal
     */
    async answerLegalQuestionnaire(requestParameters) {
        const response = await this.answerLegalQuestionnaireRaw(requestParameters);
        return await response.value();
    }
    /**
     * Adds document note to a particular attachment object
     */
    async attachmentAddDocumentReviewNoteRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling attachmentAddDocumentReviewNote.');
        }
        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId', 'Required parameter requestParameters.attachmentId was null or undefined when calling attachmentAddDocumentReviewNote.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling attachmentAddDocumentReviewNote.');
        }
        if (requestParameters.attachmentDocumentNote === null || requestParameters.attachmentDocumentNote === undefined) {
            throw new runtime.RequiredError('attachmentDocumentNote', 'Required parameter requestParameters.attachmentDocumentNote was null or undefined when calling attachmentAddDocumentReviewNote.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/attachment/{attachmentId}/review-note`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.AttachmentDocumentNoteToJSON(requestParameters.attachmentDocumentNote),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AttachmentResponseFromJSON(jsonValue));
    }
    /**
     * Adds document note to a particular attachment object
     */
    async attachmentAddDocumentReviewNote(requestParameters) {
        const response = await this.attachmentAddDocumentReviewNoteRaw(requestParameters);
        return await response.value();
    }
    /**
     * Retrieves an attachment item of a particular attachment object
     */
    async attachmentItemDownloadRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling attachmentItemDownload.');
        }
        if (requestParameters.attachmentItemId === null || requestParameters.attachmentItemId === undefined) {
            throw new runtime.RequiredError('attachmentItemId', 'Required parameter requestParameters.attachmentItemId was null or undefined when calling attachmentItemDownload.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling attachmentItemDownload.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/attachment/item/{attachmentItemId}`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))).replace(`{${"attachmentItemId"}}`, encodeURIComponent(String(requestParameters.attachmentItemId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.BlobApiResponse(response);
    }
    /**
     * Retrieves an attachment item of a particular attachment object
     */
    async attachmentItemDownload(requestParameters) {
        const response = await this.attachmentItemDownloadRaw(requestParameters);
        return await response.value();
    }
    /**
     * Adds an attachment item a particular attachment object
     */
    async attachmentItemUploadRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling attachmentItemUpload.');
        }
        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId', 'Required parameter requestParameters.attachmentId was null or undefined when calling attachmentItemUpload.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling attachmentItemUpload.');
        }
        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file', 'Required parameter requestParameters.file was null or undefined when calling attachmentItemUpload.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file);
        }
        if (requestParameters.fileName !== undefined) {
            formParams.append('fileName', requestParameters.fileName);
        }
        if (requestParameters.side !== undefined) {
            formParams.append('side', requestParameters.side);
        }
        if (requestParameters.lightSpectrum !== undefined) {
            formParams.append('lightSpectrum', requestParameters.lightSpectrum);
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/attachment/{attachmentId}`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AttachmentItemModelFromJSON(jsonValue));
    }
    /**
     * Adds an attachment item a particular attachment object
     */
    async attachmentItemUpload(requestParameters) {
        const response = await this.attachmentItemUploadRaw(requestParameters);
        return await response.value();
    }
    /**
     * Adds meta data to a particular attachment object
     */
    async attachmentMetaRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling attachmentMeta.');
        }
        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId', 'Required parameter requestParameters.attachmentId was null or undefined when calling attachmentMeta.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling attachmentMeta.');
        }
        if (requestParameters.attachmentMetaForm === null || requestParameters.attachmentMetaForm === undefined) {
            throw new runtime.RequiredError('attachmentMetaForm', 'Required parameter requestParameters.attachmentMetaForm was null or undefined when calling attachmentMeta.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/attachment/{attachmentId}/meta`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.AttachmentMetaFormToJSON(requestParameters.attachmentMetaForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AttachmentResponseFromJSON(jsonValue));
    }
    /**
     * Adds meta data to a particular attachment object
     */
    async attachmentMeta(requestParameters) {
        const response = await this.attachmentMetaRaw(requestParameters);
        return await response.value();
    }
    /**
     * Creates a new attachment for a Photo Id (scanned by the Desko scanner with the Accuant SDK) on the pod without any images. Images must be uploaded independently via the attachmentItemUpload endpoint.  See the attachmentUpload endpoint for uploading a photo id on the portal.
     */
    async attachmentPodPhotoIdUploadRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling attachmentPodPhotoIdUpload.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling attachmentPodPhotoIdUpload.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/attachments/pod-photo-ids`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.AttachmentPhotoIdCreateFormToJSON(requestParameters.attachmentPhotoIdCreateForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AttachmentPhotoIdResponseFromJSON(jsonValue));
    }
    /**
     * Creates a new attachment for a Photo Id (scanned by the Desko scanner with the Accuant SDK) on the pod without any images. Images must be uploaded independently via the attachmentItemUpload endpoint.  See the attachmentUpload endpoint for uploading a photo id on the portal.
     */
    async attachmentPodPhotoIdUpload(requestParameters) {
        const response = await this.attachmentPodPhotoIdUploadRaw(requestParameters);
        return await response.value();
    }
    /**
     * Creates a new attachment with the first side or body. This can be used for all attachments except for fingerprints and photo ids scanned at the pod.
     */
    async attachmentUploadRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling attachmentUpload.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling attachmentUpload.');
        }
        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file', 'Required parameter requestParameters.file was null or undefined when calling attachmentUpload.');
        }
        if (requestParameters.purposes === null || requestParameters.purposes === undefined) {
            throw new runtime.RequiredError('purposes', 'Required parameter requestParameters.purposes was null or undefined when calling attachmentUpload.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file);
        }
        if (requestParameters.fileName !== undefined) {
            formParams.append('fileName', requestParameters.fileName);
        }
        if (requestParameters.side !== undefined) {
            formParams.append('side', requestParameters.side);
        }
        if (requestParameters.type !== undefined) {
            formParams.append('type', requestParameters.type);
        }
        if (requestParameters.purposes) {
            formParams.append('purposes', requestParameters.purposes.join(runtime.COLLECTION_FORMATS["csv"]));
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/attachments`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AttachmentResponseFromJSON(jsonValue));
    }
    /**
     * Creates a new attachment with the first side or body. This can be used for all attachments except for fingerprints and photo ids scanned at the pod.
     */
    async attachmentUpload(requestParameters) {
        const response = await this.attachmentUploadRaw(requestParameters);
        return await response.value();
    }
    /**
     * Submit \"your info\" (name, gender, DOB)
     */
    async biographicInfoRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling biographicInfo.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling biographicInfo.');
        }
        if (requestParameters.preBiographicInfoStep === null || requestParameters.preBiographicInfoStep === undefined) {
            throw new runtime.RequiredError('preBiographicInfoStep', 'Required parameter requestParameters.preBiographicInfoStep was null or undefined when calling biographicInfo.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/biographic-info`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreBiographicInfoStepToJSON(requestParameters.preBiographicInfoStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Submit \"your info\" (name, gender, DOB)
     */
    async biographicInfo(requestParameters) {
        const response = await this.biographicInfoRaw(requestParameters);
        return await response.value();
    }
    /**
     * Get scan status for Acuant scan results prior to upload
     */
    async calculatePodPhotoIdScanStatusRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling calculatePodPhotoIdScanStatus.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling calculatePodPhotoIdScanStatus.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/attachment/pod-photo-id/scan-status`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PodPhotoIdScanStatusFormToJSON(requestParameters.podPhotoIdScanStatusForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.PhotoIdScanStatusResultFromJSON(jsonValue));
    }
    /**
     * Get scan status for Acuant scan results prior to upload
     */
    async calculatePodPhotoIdScanStatus(requestParameters) {
        const response = await this.calculatePodPhotoIdScanStatusRaw(requestParameters);
        return await response.value();
    }
    /**
     * Choose documents for pre-enrollment
     */
    async chooseDocumentsRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling chooseDocuments.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling chooseDocuments.');
        }
        if (requestParameters.preDocumentCheckStep === null || requestParameters.preDocumentCheckStep === undefined) {
            throw new runtime.RequiredError('preDocumentCheckStep', 'Required parameter requestParameters.preDocumentCheckStep was null or undefined when calling chooseDocuments.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/document-check`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreDocumentCheckStepToJSON(requestParameters.preDocumentCheckStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Choose documents for pre-enrollment
     */
    async chooseDocuments(requestParameters) {
        const response = await this.chooseDocumentsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Confirm eligibility for enrollment
     */
    async confirmEligibilityRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling confirmEligibility.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling confirmEligibility.');
        }
        if (requestParameters.preEligibilityStep === null || requestParameters.preEligibilityStep === undefined) {
            throw new runtime.RequiredError('preEligibilityStep', 'Required parameter requestParameters.preEligibilityStep was null or undefined when calling confirmEligibility.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/eligibility`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreEligibilityStepToJSON(requestParameters.preEligibilityStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Confirm eligibility for enrollment
     */
    async confirmEligibility(requestParameters) {
        const response = await this.confirmEligibilityRaw(requestParameters);
        return await response.value();
    }
    /**
     * Deletes a particular attachment object
     */
    async deleteAttachmentRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling deleteAttachment.');
        }
        if (requestParameters.attachmentId === null || requestParameters.attachmentId === undefined) {
            throw new runtime.RequiredError('attachmentId', 'Required parameter requestParameters.attachmentId was null or undefined when calling deleteAttachment.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling deleteAttachment.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/attachment/{attachmentId}`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))).replace(`{${"attachmentId"}}`, encodeURIComponent(String(requestParameters.attachmentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Deletes a particular attachment object
     */
    async deleteAttachment(requestParameters) {
        const response = await this.deleteAttachmentRaw(requestParameters);
        return await response.value();
    }
    /**
     * Describe the applicants hands prior to fingerprint scan
     */
    async describeHandsRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling describeHands.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling describeHands.');
        }
        if (requestParameters.handsModel === null || requestParameters.handsModel === undefined) {
            throw new runtime.RequiredError('handsModel', 'Required parameter requestParameters.handsModel was null or undefined when calling describeHands.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/hands/describe`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.HandsModelToJSON(requestParameters.handsModel),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Describe the applicants hands prior to fingerprint scan
     */
    async describeHands(requestParameters) {
        const response = await this.describeHandsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Confirms if all the steps for the finger prints recapture are completed.
     * Finalize (finger prints recapture)
     */
    async finalizeFingerPrintsRecaptureRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling finalizeFingerPrintsRecapture.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling finalizeFingerPrintsRecapture.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/fingerprints-recapture/finalize`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Confirms if all the steps for the finger prints recapture are completed.
     * Finalize (finger prints recapture)
     */
    async finalizeFingerPrintsRecapture(requestParameters) {
        const response = await this.finalizeFingerPrintsRecaptureRaw(requestParameters);
        return await response.value();
    }
    /**
     * Upon completion of this step, an Application ID will be generated and defined on the returned enrollment object.
     * Finalize (enrollment location, payment)
     */
    async finalizePreEnrollmentRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling finalizePreEnrollment.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling finalizePreEnrollment.');
        }
        if (requestParameters.preFinalizeStepCommand === null || requestParameters.preFinalizeStepCommand === undefined) {
            throw new runtime.RequiredError('preFinalizeStepCommand', 'Required parameter requestParameters.preFinalizeStepCommand was null or undefined when calling finalizePreEnrollment.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/finalize`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreFinalizeStepCommandToJSON(requestParameters.preFinalizeStepCommand),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Upon completion of this step, an Application ID will be generated and defined on the returned enrollment object.
     * Finalize (enrollment location, payment)
     */
    async finalizePreEnrollment(requestParameters) {
        const response = await this.finalizePreEnrollmentRaw(requestParameters);
        return await response.value();
    }
    /**
     * Finish document upload step
     */
    async finishDocumentUploadRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling finishDocumentUpload.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling finishDocumentUpload.');
        }
        if (requestParameters.preDocumentUploadStepCommand === null || requestParameters.preDocumentUploadStepCommand === undefined) {
            throw new runtime.RequiredError('preDocumentUploadStepCommand', 'Required parameter requestParameters.preDocumentUploadStepCommand was null or undefined when calling finishDocumentUpload.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/documents`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreDocumentUploadStepCommandToJSON(requestParameters.preDocumentUploadStepCommand),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Finish document upload step
     */
    async finishDocumentUpload(requestParameters) {
        const response = await this.finishDocumentUploadRaw(requestParameters);
        return await response.value();
    }
    /**
     * Gets meta data for a particular attachment type
     */
    async getAttachmentMetadataRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling getAttachmentMetadata.');
        }
        if (requestParameters.attachmentGetMetadataForm === null || requestParameters.attachmentGetMetadataForm === undefined) {
            throw new runtime.RequiredError('attachmentGetMetadataForm', 'Required parameter requestParameters.attachmentGetMetadataForm was null or undefined when calling getAttachmentMetadata.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/attachment/metadata`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.AttachmentGetMetadataFormToJSON(requestParameters.attachmentGetMetadataForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.AttachmentGetMetadataResponsePayloadFromJSON));
    }
    /**
     * Gets meta data for a particular attachment type
     */
    async getAttachmentMetadata(requestParameters) {
        const response = await this.getAttachmentMetadataRaw(requestParameters);
        return await response.value();
    }
    /**
     * A Little More About You -- identity hints
     */
    async giveIdentityHintsRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling giveIdentityHints.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling giveIdentityHints.');
        }
        if (requestParameters.preIdentityStep === null || requestParameters.preIdentityStep === undefined) {
            throw new runtime.RequiredError('preIdentityStep', 'Required parameter requestParameters.preIdentityStep was null or undefined when calling giveIdentityHints.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/identity`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreIdentityStepToJSON(requestParameters.preIdentityStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * A Little More About You -- identity hints
     */
    async giveIdentityHints(requestParameters) {
        const response = await this.giveIdentityHintsRaw(requestParameters);
        return await response.value();
    }
    /**
     * This endpoint will verify that prerequisite steps (all of them) are completed. Note: the request property creditCard.cardholderName is required.
     * Create/update payment method and then charge it for the selected plan
     */
    async paymentRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling payment.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling payment.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/payment`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PaymentInfoCommandToJSON(requestParameters.paymentInfoCommand),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * This endpoint will verify that prerequisite steps (all of them) are completed. Note: the request property creditCard.cardholderName is required.
     * Create/update payment method and then charge it for the selected plan
     */
    async payment(requestParameters) {
        const response = await this.paymentRaw(requestParameters);
        return await response.value();
    }
    /**
     * This endpoint will verify that prerequisite steps (all of them) are completed.
     * Charge payment method on file for the selected plan
     */
    async paymentChargeRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling paymentCharge.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling paymentCharge.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/payment/charge`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * This endpoint will verify that prerequisite steps (all of them) are completed.
     * Charge payment method on file for the selected plan
     */
    async paymentCharge(requestParameters) {
        const response = await this.paymentChargeRaw(requestParameters);
        return await response.value();
    }
    /**
     * Note: the request property creditCard.cardholderName is required.
     * Create/update payment method
     */
    async paymentInfoRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling paymentInfo.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling paymentInfo.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/payment/info`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PaymentInfoCommandToJSON(requestParameters.paymentInfoCommand),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Note: the request property creditCard.cardholderName is required.
     * Create/update payment method
     */
    async paymentInfo(requestParameters) {
        const response = await this.paymentInfoRaw(requestParameters);
        return await response.value();
    }
    /**
     * Provide biographic and contact info using the pod (Personal Information)
     */
    async personalInfoRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling personalInfo.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling personalInfo.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/personal-info`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PersonalInfoStepPutBodyToJSON(requestParameters.personalInfoStepPutBody),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Provide biographic and contact info using the pod (Personal Information)
     */
    async personalInfo(requestParameters) {
        const response = await this.personalInfoRaw(requestParameters);
        return await response.value();
    }
    /**
     * A Little More About You -- Address
     */
    async provideAddressesRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling provideAddresses.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling provideAddresses.');
        }
        if (requestParameters.preAddressesStep === null || requestParameters.preAddressesStep === undefined) {
            throw new runtime.RequiredError('preAddressesStep', 'Required parameter requestParameters.preAddressesStep was null or undefined when calling provideAddresses.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/addresses`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreAddressesStepToJSON(requestParameters.preAddressesStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * A Little More About You -- Address
     */
    async provideAddresses(requestParameters) {
        const response = await this.provideAddressesRaw(requestParameters);
        return await response.value();
    }
    /**
     * A Little More About You -- attributes
     */
    async provideAttributesRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling provideAttributes.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling provideAttributes.');
        }
        if (requestParameters.preAttributesStep === null || requestParameters.preAttributesStep === undefined) {
            throw new runtime.RequiredError('preAttributesStep', 'Required parameter requestParameters.preAttributesStep was null or undefined when calling provideAttributes.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/attributes`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreAttributesStepToJSON(requestParameters.preAttributesStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * A Little More About You -- attributes
     */
    async provideAttributes(requestParameters) {
        const response = await this.provideAttributesRaw(requestParameters);
        return await response.value();
    }
    /**
     * Provide contact information
     */
    async provideContactRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling provideContact.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling provideContact.');
        }
        if (requestParameters.preContactStep === null || requestParameters.preContactStep === undefined) {
            throw new runtime.RequiredError('preContactStep', 'Required parameter requestParameters.preContactStep was null or undefined when calling provideContact.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/contact`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreContactStepToJSON(requestParameters.preContactStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Provide contact information
     */
    async provideContact(requestParameters) {
        const response = await this.provideContactRaw(requestParameters);
        return await response.value();
    }
    /**
     * Provide Social Security Number for enrollment
     */
    async provideSsnRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling provideSsn.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling provideSsn.');
        }
        if (requestParameters.ssnStep === null || requestParameters.ssnStep === undefined) {
            throw new runtime.RequiredError('ssnStep', 'Required parameter requestParameters.ssnStep was null or undefined when calling provideSsn.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/ssn`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.SsnStepToJSON(requestParameters.ssnStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Provide Social Security Number for enrollment
     */
    async provideSsn(requestParameters) {
        const response = await this.provideSsnRaw(requestParameters);
        return await response.value();
    }
    /**
     * Report citizenship for pre-enrollment
     */
    async reportCitizenshipRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling reportCitizenship.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling reportCitizenship.');
        }
        if (requestParameters.preCitizenshipStep === null || requestParameters.preCitizenshipStep === undefined) {
            throw new runtime.RequiredError('preCitizenshipStep', 'Required parameter requestParameters.preCitizenshipStep was null or undefined when calling reportCitizenship.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/citizenship`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreCitizenshipStepToJSON(requestParameters.preCitizenshipStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Report citizenship for pre-enrollment
     */
    async reportCitizenship(requestParameters) {
        const response = await this.reportCitizenshipRaw(requestParameters);
        return await response.value();
    }
    /**
     * Update plan selection (Let\'s Select a Plan)
     */
    async selectPlanRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling selectPlan.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling selectPlan.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/select-plan`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PlanSelectionCommandToJSON(requestParameters.planSelectionCommand),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Update plan selection (Let\'s Select a Plan)
     */
    async selectPlan(requestParameters) {
        const response = await this.selectPlanRaw(requestParameters);
        return await response.value();
    }
    /**
     * Start an Enrollment (Let\'s Select a Plan)
     */
    async startEnrollmentRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling startEnrollment.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.authorization !== undefined && requestParameters.authorization !== null) {
            headerParameters['Authorization'] = String(requestParameters.authorization);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/select-plan`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PlanSelectionCommandToJSON(requestParameters.planSelectionCommand),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentCreatedFromJSON(jsonValue));
    }
    /**
     * Start an Enrollment (Let\'s Select a Plan)
     */
    async startEnrollment(requestParameters) {
        const response = await this.startEnrollmentRaw(requestParameters);
        return await response.value();
    }
    /**
     * Use attachmentUpload and attachmentMeta instead instead (and optionally attachmentItemUpload)
     * Upload a document for enrollment
     */
    async uploadDocumentRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling uploadDocument.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling uploadDocument.');
        }
        if (requestParameters.documentFile === null || requestParameters.documentFile === undefined) {
            throw new runtime.RequiredError('documentFile', 'Required parameter requestParameters.documentFile was null or undefined when calling uploadDocument.');
        }
        if (requestParameters.fileName === null || requestParameters.fileName === undefined) {
            throw new runtime.RequiredError('fileName', 'Required parameter requestParameters.fileName was null or undefined when calling uploadDocument.');
        }
        if (requestParameters.nameLinking === null || requestParameters.nameLinking === undefined) {
            throw new runtime.RequiredError('nameLinking', 'Required parameter requestParameters.nameLinking was null or undefined when calling uploadDocument.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters.documentFile !== undefined) {
            formParams.append('documentFile', requestParameters.documentFile);
        }
        if (requestParameters.fileName !== undefined) {
            formParams.append('fileName', requestParameters.fileName);
        }
        if (requestParameters.nameLinking !== undefined) {
            formParams.append('nameLinking', requestParameters.nameLinking);
        }
        if (requestParameters.documentType !== undefined) {
            formParams.append('documentType', requestParameters.documentType);
        }
        if (requestParameters.alienRegistrationNumber !== undefined) {
            formParams.append('alienRegistrationNumber', requestParameters.alienRegistrationNumber);
        }
        if (requestParameters.passportNumber !== undefined) {
            formParams.append('passportNumber', requestParameters.passportNumber);
        }
        if (requestParameters.passportExpiration !== undefined) {
            formParams.append('passportExpiration', requestParameters.passportExpiration);
        }
        if (requestParameters.licenseIssuingState !== undefined) {
            formParams.append('licenseIssuingState', requestParameters.licenseIssuingState);
        }
        if (requestParameters.licenseNumber !== undefined) {
            formParams.append('licenseNumber', requestParameters.licenseNumber);
        }
        if (requestParameters.licenseIssueDate !== undefined) {
            formParams.append('licenseIssueDate', requestParameters.licenseIssueDate);
        }
        if (requestParameters.licenseExpirationDate !== undefined) {
            formParams.append('licenseExpirationDate', requestParameters.licenseExpirationDate);
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/documents/upload`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Use attachmentUpload and attachmentMeta instead instead (and optionally attachmentItemUpload)
     * Upload a document for enrollment
     */
    async uploadDocument(requestParameters) {
        await this.uploadDocumentRaw(requestParameters);
    }
    /**
     * Submits the fingerprints for both hands
     */
    async uploadFingerprintsRaw(requestParameters) {
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling uploadFingerprints.');
        }
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling uploadFingerprints.');
        }
        if (requestParameters.describeHandsFingerprintsForm === null || requestParameters.describeHandsFingerprintsForm === undefined) {
            throw new runtime.RequiredError('describeHandsFingerprintsForm', 'Required parameter requestParameters.describeHandsFingerprintsForm was null or undefined when calling uploadFingerprints.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/hands/fingerprints`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.DescribeHandsFingerprintsFormToJSON(requestParameters.describeHandsFingerprintsForm),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Submits the fingerprints for both hands
     */
    async uploadFingerprints(requestParameters) {
        const response = await this.uploadFingerprintsRaw(requestParameters);
        return await response.value();
    }
    /**
     * Verify name and address information
     */
    async verifyIdentityAddressRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling verifyIdentityAddress.');
        }
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling verifyIdentityAddress.');
        }
        if (requestParameters.preIdentityAddressStep === null || requestParameters.preIdentityAddressStep === undefined) {
            throw new runtime.RequiredError('preIdentityAddressStep', 'Required parameter requestParameters.preIdentityAddressStep was null or undefined when calling verifyIdentityAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/steps/enrollment/{enrollmentId}/identity-address`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.PreIdentityAddressStepToJSON(requestParameters.preIdentityAddressStep),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Verify name and address information
     */
    async verifyIdentityAddress(requestParameters) {
        const response = await this.verifyIdentityAddressRaw(requestParameters);
        return await response.value();
    }
}
exports.EnrollmentStepsApi = EnrollmentStepsApi;
/**
    * @export
    * @enum {string}
    */
var AcceptTCAcceptanceEnum;
(function (AcceptTCAcceptanceEnum) {
    AcceptTCAcceptanceEnum["Accept"] = "accept";
    AcceptTCAcceptanceEnum["Reject"] = "reject";
})(AcceptTCAcceptanceEnum = exports.AcceptTCAcceptanceEnum || (exports.AcceptTCAcceptanceEnum = {}));
/**
    * @export
    * @enum {string}
    */
var AttachmentUploadPurposesEnum;
(function (AttachmentUploadPurposesEnum) {
    AttachmentUploadPurposesEnum["FACIALIDENTIFICATION"] = "FACIAL_IDENTIFICATION";
    AttachmentUploadPurposesEnum["FINGERPRINTIDENTIFICATION"] = "FINGERPRINT_IDENTIFICATION";
    AttachmentUploadPurposesEnum["CITIZENSHIP"] = "CITIZENSHIP";
    AttachmentUploadPurposesEnum["NAMELINKING"] = "NAME_LINKING";
    AttachmentUploadPurposesEnum["PHOTOID"] = "PHOTO_ID";
})(AttachmentUploadPurposesEnum = exports.AttachmentUploadPurposesEnum || (exports.AttachmentUploadPurposesEnum = {}));
//# sourceMappingURL=EnrollmentStepsApi.js.map